"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyWidgetService = void 0;
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
/**
 * Exposes functionality meant to be used by third party widgets
 */
var ThirdPartyWidgetService = /** @class */ (function () {
    function ThirdPartyWidgetService(flowingPages, pageLayoutService, widgetOperationsService, widgetManager, navigationService) {
        this.flowingPages = flowingPages;
        this.pageLayoutService = pageLayoutService;
        this.widgetOperationsService = widgetOperationsService;
        this.widgetManager = widgetManager;
        this.navigationService = navigationService;
    }
    /**
     * Update the dimensions of the container the widget is rendered in, and then trigger a RESIZE event.
     * This will only update the dimensions if they are SMALLER than the current dimensions.
     * Otherwise, keep the current dimensions.
     * This is to prevent us from resizing a container smaller after the user manually resized it to be larger.
     * We should only resize the container to be larger (e.g. to fit more data that has come in)
     */
    ThirdPartyWidgetService.prototype.updateContainerDimensions = function (widgetId, proposedStyle) {
        var _this = this;
        var widget = this.flowingPages.getWidget(widgetId);
        // @ts-ignore
        var currentStyle = this.pageLayoutService.convertLayoutToStyle(widget.layout);
        proposedStyle = lodash_1.default.merge(currentStyle, proposedStyle);
        var proposedLayout = this.pageLayoutService
            // @ts-ignore
            .convertStyleToLayout(proposedStyle, widget.layout, true, true);
        // @ts-ignore
        var newWidgetLayout = this.getNewLayout(widget.layout, proposedLayout);
        if (!lodash_1.default.isEqual(widget.layout, newWidgetLayout)) {
            widget.layout = newWidgetLayout;
            // Give the widget layout event handler a chance to apply the new layout before notifying the widget to resize
            setTimeout(function () {
                _this.widgetManager.notifyWidget(widgetId, 'resized', 'prWidget.onResize');
                _this.flowingPages.reflow();
                if (!_this.navigationService.isExport) {
                    _this.widgetOperationsService.finishTransform([widget]);
                }
            });
        }
    };
    /**
     * Set the minimum dimensions that the widget container can be resized to.
     * This will not resize the container to those dimensions.
     * It just prevents the user from manually resizing smaller than the passed in dimensions.
     */
    ThirdPartyWidgetService.prototype.setMinDimensions = function (widgetId, dimensions) {
        // Wait for widget to render
        setTimeout(function () {
            var el = $("pr-widget[selectionid=" + widgetId + "]");
            el.attr('minWidth', dimensions.width ? dimensions.width : null);
            el.attr('minHeight', dimensions.height ? dimensions.height : null);
        });
    };
    /**
     * Get the new layout for the widget. If the current layout is larger than the proposed layout,
     * then keep the current layout. This is to prevent us from resizing the widget to be smaller
     * after the user resized the widget to be larger.
     */
    ThirdPartyWidgetService.prototype.getNewLayout = function (currentLayout, proposedLayout) {
        return __assign(__assign({}, proposedLayout), { rowSpan: Math.max(currentLayout.rowSpan, proposedLayout.rowSpan), colSpan: Math.max(currentLayout.colSpan, proposedLayout.colSpan) });
    };
    ThirdPartyWidgetService.$inject = [
        'prFlowingPages',
        'prPageLayoutService',
        'pr.widgetOperationsService',
        'pr.widgetManager',
        'pr.navigationService'
    ];
    return ThirdPartyWidgetService;
}());
exports.ThirdPartyWidgetService = ThirdPartyWidgetService;
(function (module) {
    module.service('pr.thirdPartyWidgetService', ThirdPartyWidgetService);
})(angular_1.module('qualtrics.pr'));
